import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurEnBetalingen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Huur_en_betalingen_svg__a"
      width={30}
      height={16}
      x={5}
      y={12}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5 12v16h30V12z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#Huur_en_betalingen_svg__a)">
      <path
        fill="#6FBC85"
        d="m-4.495 5.86 12.25 7.07L14.825.68z"
      />
      <path
        fill="#00A75D"
        d="M7.755 12.93.68 25.175 20 20z"
      />
      <path
        fill="#6FBC85"
        d="m5.86 44.495 7.07-12.245L.68 25.175z"
      />
      <path
        fill="#00A75D"
        d="m25.175 39.32 7.07-12.25L20 20z"
      />
      <path
        fill="#6FBC85"
        d="m20 20-7.07 12.25 12.245 7.07z"
      />
      <path
        fill="#00A75D"
        d="M39.32 14.825 32.245 27.07l12.25 7.07z"
      />
      <path
        fill="#6FBC85"
        d="M39.32 14.825 27.07 7.75 20 20z"
      />
      <path
        fill="#00A75D"
        d="M-4.495 5.86.68 25.175 7.755 12.93z"
      />
      <path
        fill="#6FBC85"
        d="m.68 25.175 12.25 7.075L20 20z"
      />
      <path
        fill="#00A75D"
        d="m20 20 12.245 7.07 7.075-12.245z"
      />
      <path
        fill="#6FBC85"
        d="m44.495 34.14-12.25-7.07-7.07 12.25z"
      />
      <path
        fill="#00A75D"
        d="m20 20 7.07-12.25L14.825.68z"
      />
      <path
        fill="#6FBC85"
        d="m14.825.68-7.07 12.25L20 20zM34.14-4.495 27.07 7.75l12.25 7.075z"
      />
    </g>
    <path
      fill="#A8D3AF"
      fillRule="evenodd"
      d="M8.25 28A3.25 3.25 0 0 0 5 24.75V28zM5 15.25A3.25 3.25 0 0 0 8.25 12H5zM31.75 12A3.25 3.25 0 0 0 35 15.25V12zM35 24.75A3.25 3.25 0 0 0 31.75 28H35z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M20.64 16.4c.915 0 1.78.355 2.44 1L25 15.76a6.23 6.23 0 0 0-4.36-1.755c-2.985 0-5.47 2.06-6.04 4.8H13v2.4h1.6c.57 2.74 3.06 4.8 6.04 4.8 1.705 0 3.245-.67 4.36-1.755l-1.92-1.64c-.66.645-1.525 1-2.44 1-1.51 0-2.845-.985-3.335-2.4h3.585v-2.4h-3.585c.49-1.415 1.82-2.4 3.335-2.4z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurEnBetalingen);

export default ForwardRef;
